import React, { FC, useEffect, useState } from "react";
import { appInsights, reactPlugin, withAITracking } from "../../../appInsights";
import memberDetailsService from "@services/memberDetails.service";
import { useNavigate } from "react-router-dom";
import membersService from "@services/members.service";
import { routeMap } from "@utils/constants";
import Icon from "@assets/icon_config";
import Sections from "./sections";

const ContactDetails: FC<any> = (props) => {
  const [loadingForContact, setContactLoaderFlag] = useState(false);
  const [contactDetailsData, setContactDetailsData] = useState<any>({});
  const defaultExpandedCards = ["32"];
  const expandAllCards = ["32", "30", "31", "8", "29", "41"];
  const patientId = membersService?.getCurrentMember?.patient_id;
  const [activePanels, setActivePanels] = useState<any>(defaultExpandedCards);

  const navigate = useNavigate();

  useEffect(() => {
    console.log("ContactDetails.useEffect1");
    appInsights.trackPageView({ name: "Contact Details" });
  }, []);

  useEffect(() => {
    setActivePanels(defaultExpandedCards);
    if (patientId) {
      getContactDetails(patientId);
    } else navigate(routeMap["members"]);
  }, [patientId, navigate]);

  const changeCollapse = () => {
    if (activePanels?.length > 0) {
      setActivePanels([]);
    } else {
      setActivePanels(expandAllCards);
    }
  };

  const getContactDetails = (id: number) => {
    console.log("ContactDetails.getContactDetails");
    setContactLoaderFlag(true);
    memberDetailsService.getContactDetails(id).subscribe({
      next: (v) => {
        console.log(v);
        setContactLoaderFlag(false);
        setContactDetailsData(v.data.data.contactDetailsData);
      },
      error: (e) => {
        console.log(e);
        setContactLoaderFlag(false);
        setContactDetailsData({});
      },
    });
  };

  return (
    <>
      <div className="member-detail-tab-header">
        <div className="member-detail-tab-header__collapse-all-button" onClick={changeCollapse}>
          <span className="member-detail-tab-header__collapse-all-button__title">{activePanels?.length > 0 ? "Collapse All" : "Expand All"} </span>
          <span className={`member-detail-tab-header__collapse-all-button__arrow ${activePanels?.length > 0 ? "" : "arrow-down"}`}>
            <Icon name={`${activePanels?.length > 0 ? "arrowUp" : "arrowDown"}`} colorOfBrand={"#0072E3"} />
          </span>
        </div>
      </div>

      <Sections
        contactDetailsData={contactDetailsData}
        activePanels={activePanels}
        setActivePanels={setActivePanels}
        pinChangeHandler={props.pinChangeHandler}
        pinCardIds={props.pinCardIds}
        loadingForContact={loadingForContact}
      />
    </>
  );
};

export default withAITracking(reactPlugin, ContactDetails);
